import { OPTIONS_PER_VIEW, OPTION_HEIGHT } from './config';

/**
 * Дает позицию при скролле вверх/вниз
 * @param next Индекс следующего элемента
 * @param top Текущая позиция скролла
 */
export const getScroll = (next: number, top: number) => {
    /** Высота неактивных элементов */
    const viewHeight = OPTION_HEIGHT * (OPTIONS_PER_VIEW - 1);
    const bottom = top + viewHeight;
    const nextPos = next * OPTION_HEIGHT;

    if (nextPos > bottom) {
        return nextPos - viewHeight;
    }
    if (nextPos < top) {
        return nextPos;
    }

    return top;
};
